var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loading'):_c('router-view',{staticClass:"py-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }